import { render, staticRenderFns } from "./UButtonB.vue?vue&type=template&id=72b21f38&scoped=true&"
import script from "./UButtonB.vue?vue&type=script&lang=js&"
export * from "./UButtonB.vue?vue&type=script&lang=js&"
import style0 from "./UButtonB.vue?vue&type=style&index=0&id=72b21f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b21f38",
  null
  
)

export default component.exports